import './js/global'
import './js/header'

// Feed.
import './js/feed/certification'
import './js/feed/seedling-type'

// Blocks.
import './js/blocks/faq'
import './js/blocks/offer'

// Pages.
import './js/pages/devis'
import './js/pages/faq'
import './js/pages/home'
import './js/pages/seedlings'

// Parts.
import './js/parts/contact'
import './js/parts/filter'
import './js/parts/seedling-search'

// Single.
import './js/single/seedling'
